import type { Client, Invoice, Business } from '@/lib/api';
import { invoiceApi } from '@/lib/api';
import { SendDocumentModal, type SendMode } from './SendDocumentModal';

interface SendInvoiceModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invoice: Invoice;
  client: Client | null;
  business: Business | null;
  mode?: SendMode;
  onSend: (data: {
    medium: 'email' | 'sms';
    to: string[];
    cc: string[];
    bcc: string[];
    subject: string;
    message: string;
    cc_self: boolean;
  }) => Promise<void>;
}

export function SendInvoiceModal({
  open,
  onOpenChange,
  invoice,
  client,
  business,
  mode = 'send',
  onSend,
}: SendInvoiceModalProps) {
  return (
    <SendDocumentModal
      open={open}
      onOpenChange={onOpenChange}
      documentType="invoice"
      documentId={invoice.id}
      documentNumber={invoice.invoice_number || invoice.id}
      noteForClient={invoice.note_for_client}
      client={client}
      business={business}
      mode={mode}
      getSendTemplate={(id, medium) => invoiceApi.getSendTemplate(id, medium, mode === 'reminder' ? 'reminder' : undefined)}
      onSend={onSend}
    />
  );
}
